import { replaceUrlParams } from '@catalogo/service-americanas-product/src/helpers/url';

export const fmtProps = props => {
  const { address, number, neighborhood } = props?.store?.address ?? {};
  const fullAddress = `${address}, ${number}, ${neighborhood}`;

  return {
    name: props?.store?.name,
    address: fullAddress,
    openModal: replaceUrlParams(props?.history, '#modal-select-store', false),
    distance: props?.store?.distance?.toFixed(2),
    isMobile: props?.device === 'mobile',
  };
};
